"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosTaxCategoryUpdateInputSchema = exports.APosTaxCategoryCreateInputSchema = exports.APosTaxCategorySchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosTaxCategorySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    taxCategoryId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    defaultRate: zod_1.z.number().min(0).max(1).describe('Decimal tax rate'),
    isDefault: zod_1.z.boolean().default(false),
    isExempt: zod_1.z.boolean().default(false),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosTaxCategoryCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    defaultRate: zod_1.z.number().min(0).max(1),
    isDefault: zod_1.z.boolean().optional(),
    isExempt: zod_1.z.boolean().optional(),
});
exports.APosTaxCategoryUpdateInputSchema = exports.APosTaxCategoryCreateInputSchema.partial();
//# sourceMappingURL=tax-category.schema.js.map